import axios from 'axios'
import ApiService from '@/common/api.service'
import { API_URL } from '@/common/config'

// The member-facing (non-admin) password-reset endpoints below are all genuinely public,
// unauthenticated ones - an anonymous visitor who forgot their password has no session at all.
// Deliberately not using ApiService/Vue.axios: that shared instance can carry a stale
// Authorization header from unrelated browser state, which would 401 here and trigger a doomed
// refresh-and-logout cycle. A fresh, header-free instance sidesteps this entirely (mirrors
// member-client.js's own publicAxios / refresh.service.js's axiosInstanceForRefresh).
const publicAxios = axios.create({ baseURL: API_URL })

export default {
  sendResetPassword (code, newPassword, verificationCode) {
    const data = {
      'code': code,
      'newPassword': newPassword,
      'verificationCode': verificationCode
    }
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/resetPassword', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendCode (code) {
    const data = {
      'code': code
    }
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/verifyPasswordReset', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendPasswordResetOtc (resetCode) {
    const data = {
      'resetCode': resetCode
    }
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/password-reset/otc/send', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendRegistPasswordResetMail (contact, dateOfBirth) {
    const data = {
      'reminderAddress': contact,
      'dateOfBirth': dateOfBirth
    }
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/requestPasswordReset', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // ログインID通知 (01_auth_and_login_api.md §4.3) - public, so it goes through publicAxios too.
  sendLoginIdNotification (reminderAddress, dateOfBirth) {
    const data = {
      'reminderAddress': reminderAddress,
      'dateOfBirth': dateOfBirth
    }
    return new Promise((resolve, reject) => {
      publicAxios.post('/member/requestLoginIdNotification', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendResetPasswordAdmin (code, newPassword) {
    const data = {
      'code': code,
      'newPassword': newPassword
    }
    return new Promise((resolve, reject) => {
      ApiService.post('/admin/resetPassword', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendCodeAdmin (code) {
    const data = {
      'code': code
    }
    return new Promise((resolve, reject) => {
      ApiService.post('/admin/verifyPasswordReset', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sendRegistPasswordResetMailAdmin (contact) {
    const data = {
      'reminderAddress': contact
    }
    return new Promise((resolve, reject) => {
      ApiService.post('/admin/requestPasswordReset', data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
